import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag, faMapMarkerAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import DataAdapter from './adapter/DataAdapter';

const TenderBoard = () => {
  const [tenders, setTenders] = useState([]);
  const [activeTender, setActiveTender] = useState(null);

  useEffect(() => {
    (new DataAdapter("SELECT * FROM rb_tenders;")).getRecords()
      .then(response => {
        setTenders(response);
      });
  }, []);

  const toggleCardBody = (td_id) => {
    setActiveTender(activeTender === td_id ? null : td_id);
  };

  return (
    <div className="p-4">
      <h1 className="mb-4">Tender Board</h1>
      <Row>
        {tenders.map(tender => (
          <Col key={tender.td_id} xs="12" sm="6" md="4" lg="3" className="mb-4">
            <Card className="shadow-sm h-100" onClick={() => toggleCardBody(tender.td_id)}>
              <CardHeader style={{ backgroundColor: '#004085', color: 'white' }}>
                {/* Tender Number */}
                <div className="mb-2">
                  <FontAwesomeIcon icon={faHashtag} className="mr-1" />
                  {tender.td_tender_number}
                </div>
                {/* Tender Title */}
                <div><strong>{tender.td_tender_title}</strong></div>
                {/* Location */}
                <div className="mb-2">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1" />
                  {tender.location}
                </div>
                {/* Deadline in Red */}
                <div style={{ color: 'red', fontSize: '0.875rem' }}>
                  <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                  {tender.deadline}
                </div>
              </CardHeader>
              {activeTender === tender.td_id && (
                <CardBody style={{ fontSize: '0.875rem' }}>
                  <p><strong>Issuing Organization:</strong> {tender.td_issuing_org}</p>
                  <p><strong>Estimated Project Value:</strong> {tender.estimated_project_value}</p>
                  <p><strong>Required Bonds:</strong> {tender.required_bonds}</p>
                  <p><strong>Required Certifications:</strong> {tender.required_certifications}</p>
                  <p><strong>Notes:</strong> {tender.notes}</p>
                  <p><strong>Submission Method:</strong> {tender.submission_method}</p>
                  <p><strong>Site Visit:</strong> {tender.site_visit}</p>
                  <p><strong>Date of Site Visit:</strong> {tender.date_site_visit}</p>
                  <p><strong>Last Day for Questions:</strong> {tender.last_day_for_questions}</p>
                  <p><strong>Evaluation Criteria:</strong> {tender.evaluation_criteria}</p>
                  <p><strong>Schedule:</strong> {tender.schedual}</p>
                  <p><strong>Environmental:</strong> {tender.environmental}</p>
                  <p><strong>Traffic:</strong> {tender.traffic}</p>
                </CardBody>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TenderBoard;
